import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import OrderRepository from "../../../repository/OrderRepository";
import { __remove, __set } from "../../axios_indicator";

export const fetchOrderList = createAsyncThunk('order_fetchOrderList', async (params) => {
    __set('ORDER_API_CALL');
    return await new OrderRepository().fetchOrderList(params.keyword, params.searchType, params.timeSpan, params.start, params.pageSize, params.sortBy, params.sortOrder, params.filterByOption, params.continuationToken)
});


export const fetchPlaceOrderItems = createAsyncThunk('order_fetchPlaceOrderItems', async (orderId) => {
    return await new OrderRepository().fetchPlaceOrderItems(orderId)
});
export const fetchExportOrderCount = createAsyncThunk('order_fetchExportOrderCount', async () => {
    __set('ORDER_EXPORT_COUNT_API_CALL');
    return await new OrderRepository().fetchOrderExportCount();
});

export const fetchManufacturerList = createAsyncThunk('order_fetchManufacturerList', async () => {
    return await new OrderRepository().fetchManufacturerList();
});
export const getValidateOrderFromServer = createAsyncThunk('order_fetchValidateOrderFromServer', async (params) => {
    __set('VALIDATE_ORDER_API_CALL');
    return await new OrderRepository().getValidateOrderFromServer(params);
});
export const getOrderItemList = createAsyncThunk('order_getOrderItemList', async (params) => {
    __set('ORDER_ITEM_LIST_API_CALL');
    return await new OrderRepository().getOrderItemList(params);
});
export const fetchOrderDetail = createAsyncThunk('order_getDetail', async (params) => {
    __set('GET_ORDER_DETAIL');
    return await new OrderRepository().fetchOrderDetail(params);
});

const initialState = {
    orderList: {},
    placeOrderItemList: {},
    placeOrderLoading: false,
    orderExportCount: 0,
    orderManuFactureList: [],
    orderItemList: {},
    orderParams: {},
    orderDetail: {},
    validateOrderFromServer: {}
};
const slice = createSlice({
    name: "Order",
    initialState: initialState,
    reducers: {
        setPlaceOrderLoading: {
            reducer: (state, action) => {
                state.placeOrderLoading = action.payload
            }
        },
        setOrderParams: {
            reducer: (state, action) => {
                state.orderParams = action.payload
            }
        }
    },
    extraReducers: {
        [fetchOrderList.fulfilled]: (state, { payload }) => {
            state.orderList = payload;
            setTimeout(() => {
                __remove('ORDER_API_CALL');
            }, 2000);
            return state;
        },
        [fetchOrderList.rejected]: (state, { payload }) => {
            setTimeout(() => {
                __remove('ORDER_API_CALL');
            }, 2000);
        },
        [getValidateOrderFromServer.fulfilled]: (state, { payload }) => {
            state.validateOrderFromServer = payload;
            __remove('VALIDATE_ORDER_API_CALL');

            return state;
        },
        [getValidateOrderFromServer.rejected]: (state, { payload }) => {
            __remove('VALIDATE_ORDER_API_CALL');

        },
        [fetchPlaceOrderItems.fulfilled]: (state, { payload }) => {
            state.placeOrderItemList = payload;
            return state
        },
        [fetchPlaceOrderItems.rejected]: (state, { payload }) => {
        },
        [fetchExportOrderCount.fulfilled]: (state, { payload }) => {

            state.orderExportCount = payload;
            __remove('ORDER_EXPORT_COUNT_API_CALL');
        },
        [fetchExportOrderCount.rejected]: (state, { payload }) => {
            __remove('ORDER_EXPORT_COUNT_API_CALL');
        },
        [fetchManufacturerList.fulfilled]: (state, { payload }) => {
            state.orderManuFactureList = payload;
            return state;
        },
        [fetchManufacturerList.rejected]: (state, { payload }) => {

        },
        [getOrderItemList.fulfilled]: (state, { payload }) => {
            state.orderItemList = payload;
            __remove('ORDER_ITEM_LIST_API_CALL');

            return state;
        },
        [getOrderItemList.rejected]: (state, { payload }) => {
            __remove('ORDER_ITEM_LIST_API_CALL');
        },
        [fetchOrderDetail.fulfilled]: (state, { payload }) => {
            state.orderDetail = payload;
            __remove('GET_ORDER_DETAIL');
        },
        [fetchOrderDetail.rejected]: (state, { payload }) => {
            __remove('GET_ORDER_DETAIL');
        },
    },
});

export let { setPlaceOrderLoading, setOrderParams } = slice.actions;

export default slice.reducer;
